export default __webpack_public_path__ + "static/media/background-4.37db48e3.jpg";